module.exports = __webpack_public_path__ + "img/orange-cake.09daaa57.jpg";